import { render, staticRenderFns } from "./BorrowerProfileWarning.vue?vue&type=template&id=3d8d3ca6"
import script from "./BorrowerProfileWarning.vue?vue&type=script&lang=js"
export * from "./BorrowerProfileWarning.vue?vue&type=script&lang=js"
import style0 from "./BorrowerProfileWarning.vue?vue&type=style&index=0&id=3d8d3ca6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports